import JoinExp from 'components/join-exp';
import { expRealtyUSTenant, isTenantExpUS, TenantTypes } from '@tenants';
import { useTrackExpOnlyEvents } from 'hooks/use-track-exp-only-events';
import { NOT_FOUND } from 'constants/not-found';
import { GTM_JOIN_EXP_SCRIPT } from 'constants/HTMLAttributes';
import { HandlerType, createGetServerSideProps } from 'utils/next/shared-getServerSideProps';
import { useUserContext } from 'contexts';
import { GtmScript } from 'components/gtm-script';
import { Namespaces } from 'types/locales';

import type { GetServerSidePropsContext } from 'next';
import type { FeaturesType } from 'contexts';

type JoinExpPageUsProps = {
  joinExpFabDestination?: string;
};

const handler: HandlerType = async (_context: GetServerSidePropsContext, features?: FeaturesType, tenant?: TenantTypes) => {
  // Only allow access to this page on the eXp US tenant
  if (!isTenantExpUS(tenant.id, features)) {
    return NOT_FOUND;
  }
  return { props: {}};
};

export const getServerSideProps = createGetServerSideProps(handler, [
  Namespaces.JOIN_EXP_US, // For join page content
  Namespaces.COMMON, // For common buttons and labels
  Namespaces.EXP_REALTY_US, // For tenant-specific translations (footer, etc)
] as const);

function JoinExpPageUs({ joinExpFabDestination }: JoinExpPageUsProps) {
  const { config: { joinExp }, googleTagManager: { containerIds }} = expRealtyUSTenant;
  const { trackExpEvent } = useTrackExpOnlyEvents();
  const { functionalCookiesEnabled } = useUserContext();

  const config = {
    ...joinExp,
    fabDestination: joinExpFabDestination ?? joinExp.fabDestination,
  };

  const onLearnMoreClick = () => trackExpEvent(joinExp.learnMoreClickEvent);
  const onBuiltForThisJoinUsClick = () => trackExpEvent(joinExp.builtForThis.clickEvent);
  const onSignMeUpClick = () => trackExpEvent(joinExp.signMeUpClickEvent);
  const onGetNowClick = () => trackExpEvent(joinExp.getNowClickEvent);
  const onProgramButtonClick = (index: number) => trackExpEvent(joinExp.programsData[index].buttonClickEvent);
  const onFabClick = () => trackExpEvent(joinExp.fabClickEvent);

  return (
    <>
      <GtmScript id={GTM_JOIN_EXP_SCRIPT} strategy="beforeInteractive" containerId={containerIds.JoinExpUs} functionalCookiesEnabled={functionalCookiesEnabled} />
      <JoinExp
        config={config}
        onLearnMoreClick={onLearnMoreClick}
        onBuiltForThisJoinUsClick={onBuiltForThisJoinUsClick}
        onSignMeUpClick={onSignMeUpClick}
        onGetNowClick={onGetNowClick}
        onProgramButtonClick={onProgramButtonClick}
        onFabClick={onFabClick}
      />
    </>
  );
}

export default JoinExpPageUs;
